import React from 'react';

import AccordionComponent from '../../../core/components/accordion/accordion';
import { AccordionItem } from '../../../core/components/accordion/accordion-types';
import { withAppComponent } from '../../../core/hocs/with-app-component/with-app-component';

const Accordion = withAppComponent<{
  items?: AccordionItem[];
}>(({ items }) => {
  if (!items) {
    return null;
  }

  return <AccordionComponent items={items} scroll />;
});

export default Accordion;
